import { equalFlatObjects as e } from "./object.js";
//#region src/utils/array.ts
function t(t, n) {
	if (t === n || t.length === 0 && n.length === 0) return !0;
	if (t.length !== n.length) return !1;
	for (let r = 0; r < t.length; ++r) if (!e(t[r], n[r])) return !1;
	return !0;
}
var n = (e, t) => {
	if (e === t) return !0;
	if (e.length !== t.length) return !1;
	for (let n = 0; n < e.length; ++n) if (e[n] !== t[n]) return !1;
	return !0;
}, r = (e, t) => {
	e.sort((e, n) => {
		let r = 0, i = 0;
		for (; r < t.length && i === 0;) {
			let { criterion: o, direction: s } = t[r];
			i = s;
			let c, l;
			a(o) ? (c = parseFloat(String(e[o])) || String(e[o]), l = parseFloat(String(n[o])) || String(n[o])) : (c = o(e), l = o(n)), c < l ? i *= -1 : c > l ? i *= 1 : i = 0, r++;
		}
		return i;
	});
}, i = (e, t) => {
	let n = {};
	for (let r of e) {
		let e = r[t];
		n[e] = n[e] ? n[e] + 1 : 1;
	}
	return n;
};
function a(e) {
	return typeof e == "string";
}
//#endregion
export { i as countValues, t as equalObjArrays, n as equalPrimitiveArrays, r as sortObjArrayBy };
